"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionColumnProperties = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var SectionColumnProperties = (function () {
    function SectionColumnProperties(width, space) {
        this.width = 0;
        this.space = 0;
        this.width = width;
        this.space = space;
    }
    SectionColumnProperties.prototype.equals = function (obj) {
        if (!obj)
            return false;
        return this.width == obj.width &&
            this.space == obj.space;
    };
    SectionColumnProperties.prototype.copyFrom = function (obj) {
        this.width = obj.width;
        this.space = obj.space;
    };
    SectionColumnProperties.prototype.clone = function () {
        return new SectionColumnProperties(this.width, this.space);
    };
    SectionColumnProperties.prototype.applyConverter = function (converter) {
        this.width = converter(this.width);
        this.space = converter(this.space);
        return this;
    };
    SectionColumnProperties.equalsColumnsInfoBinary = function (a, b) {
        return a && b && (a === b || a.length == b.length && list_1.ListUtils.allOf2(a, b, function (valA, valB) { return valA.equals(valB); }));
    };
    return SectionColumnProperties;
}());
exports.SectionColumnProperties = SectionColumnProperties;
